import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';

/**
 * Map DB row to JS-friendly shape for ActionLog UI.
 *
 * DB schema: { id, action, category, description, user, job_id, job_title, timestamp }
 * UI expects: { id, action, category, description, user, jobId, jobTitle, createdAt }
 */
function mapFromDb(row) {
  return {
    id: row.id,
    action: row.action,
    category: row.category,
    description: row.description,
    user: row.user || null,
    jobId: row.job_id || null,
    jobTitle: row.job_title || null,
    data: row.data || null,
    createdAt: row.timestamp,
  };
}

const PAGE_SIZE = 50;

export function useActionLog(limit = PAGE_SIZE) {
  return useQuery({
    queryKey: [...queryKeys.actionLog.all, limit],
    queryFn: async () => {
      const data = await api.get(`/action-log?order=timestamp&dir=desc&limit=${limit}`);
      return { entries: data.map(mapFromDb), total: data.length };
    },
  });
}

export function useLogAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (logEntry) => {
      const data = await api.post('/action-log', logEntry);
      return mapFromDb(data);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.actionLog.all });
    },
  });
}
